import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterName'
})
export class FilterByPipe implements PipeTransform {

    transform(items: any[], searchText: string): any[] {

        if (!items)
            return [];

        if (!searchText)
            return items;

        //return items.filter(items => items.name === searchText);

        return items.filter(
            item =>
                item.xgroupid.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 ||
                item.descrtec.toUpperCase().indexOf(searchText.toUpperCase()) !== -1

        );

    }
}